import React from "react";
import { image } from "../../Assets";
import "./specialitySection.scss";
import Counter from "../Counter/Counter";

const SpecialitySection = () => {
  const sectors = [
    { title: "Education", img: image.educationSectorImg },
    { title: "Construction", img: image.constructiomsector },
    { title: "Hospitality", img: image.hospitalitysector },
    { title: "Healthcare", img: image.healthcaresector },
  ];

  return (
    <section className="speciality-Section tw-py-[60px] md:tw-py-[100px]" id="Industries">
      <div className="container tw-max-w-[1320px] tw-mx-auto tw-px-4 sm:tw-px-6 md:tw-px-0">
        <h2 className="tw-text-3xl sm:tw-text-4xl lg:tw-text-[45px] 
          tw-font-semibold tw-text-[#157438] tw-mb-8">
          Who we work with
        </h2>

        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-6">
          {sectors.map((item, index) => (
            <div
              key={index}
              className="speciality-card tw-relative tw-h-[320px] sm:tw-h-[380px] lg:tw-h-[450px]
                tw-rounded-[20px] tw-overflow-hidden
                tw-flex tw-items-end tw-p-6
                group tw-cursor-pointer"
            >
              {/* Background Image Container */}
              <div 
                className="tw-absolute tw-inset-0 tw-bg-cover tw-bg-no-repeat tw-bg-center tw-scale-100 tw-transition-transform tw-duration-500 tw-ease-out"
                style={{ backgroundImage: `url(${item.img})` }}
              />
              
              {/* Gradient Overlay */}
              <div className="tw-absolute tw-inset-0 
                tw-bg-gradient-to-b 
                tw-from-transparent 
                tw-to-[#27914e] tw-opacity-90 
                tw-transition-opacity tw-duration-300 tw-ease-out
                group-hover:tw-opacity-75" />

              <h4 className="tw-relative tw-z-10 tw-text-white tw-text-xl tw-font-semibold
                tw-transition-all tw-duration-300 tw-ease-out
                group-hover:tw-translate-y-[-5px] group-hover:tw-scale-105">
                {item.title}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecialitySection;